/**
 * @ngdoc directive
 * @name directiveRaceReplay
 * @restrict A
 *
 * @description
 * Directive for raceReplay block
 *
 * @element ANY
 */
export default function () {
    return {
        restrict: 'A',
        controller: 'raceReplayCtrl',
        scope: true,
    };
}



// WEBPACK FOOTER //
// ./src/js/directives/raceReplay.js